import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {removeLocalLogoByLocalId} from '../../../../../../../../crud/management_api/local_configurations';
import './LogoViewer.scss';
import {toast} from 'react-toastify';
import MiniLoadingSpinner from '../../../../../../../../components/Spinners/MiniLoadingSpinner';

interface LogoViewerProps {
  imageUrl: string;
  onRemove: () => void;
}

const LogoViewer: React.FC<LogoViewerProps> = ({ imageUrl, onRemove }) => {
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleRemoveClick = () => {
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setLoading(true);
    const user = localStorage.getItem('user');
    const localId = user ? JSON.parse(user).local_id : 0;
    removeLocalLogoByLocalId(localId).then(() => {
      onRemove();
      toast.success('Logo eliminado correctamente');
    }).catch((error) => {
      console.error(error);
      toast.error('Error al eliminar el logo');
    }).finally(() => {
      setLoading(false);
    });
    setShowConfirm(false);
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  return (
    <div className="logo-viewer">
      <div className="logo-container">
        <img src={imageUrl} alt="Logo del restaurante" className="logo-image" />
        <button className="remove-button" onClick={handleRemoveClick}>
          &times;
        </button>
      </div>
      <Modal show={showConfirm} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar logo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro de que desea eliminar el logo?</p>
          {loading && <MiniLoadingSpinner />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LogoViewer;
